import request from './request_A'

// 获取未投保页信息
const uninsuredInfo = (data) => {
  return request({
      url:process.env.VUE_APP_JAHOST+'/backend/insurance/getUninsured',
      data:{
        loading:true, //请求接口时若需展示公共loading 
        ...data
      },
      method: 'POST',
  })
}
// 获取已投保页信息
const getInsuredInfo = (data) => {
  return request({
      url:process.env.VUE_APP_JAHOST+'/backend/insurance/getInsured',
      data:{
        loading:true, //请求接口时若需展示公共loading 
        ...data
      },
      method: 'POST',
  })
}
// 校验卡券
const checkCoupon = (data) => {
  return request({
      url:process.env.VUE_APP_JAHOST+'/backend/insurance/check-coupon',
      params:{
        loading:true, //请求接口时若需展示公共loading 
        ...data
      },
      method: 'GET',
  })
}

// 获取医美商品信息
const beautyPage = (data) => {
  return request({
      url:process.env.VUE_APP_JAHOST+'/backend/insurance/beautyPage',
      params:{
        loading:true, //请求接口时若需展示公共loading 
        ...data
      },
      method: 'GET',
  })
}

export {
  uninsuredInfo,
  getInsuredInfo,
  checkCoupon,
  beautyPage
}